// Misc app-wide constants.

/** Default page size for server-side (offset) paginated lists — assets, drill-downs. */
export const DEFAULT_PAGE_SIZE = 24;

/** Page-size options offered in list toolbars. Backend clamps >100 to 100. */
export const PAGE_SIZE_OPTIONS = [12, 24, 48, 96];

/** How many documents to pull per page when eagerly loading the (chapter-scale) collection. */
export const DOCUMENTS_FETCH_PAGE = 100;

/** Safety cap so an unexpectedly huge collection can't fire unbounded requests. */
export const DOCUMENTS_FETCH_CAP = 1000;

/** Poll interval (ms) while a document is ingesting or assets are running. */
export const POLL_INTERVAL_MS = 5000;

/** Poll interval (ms) for the live system-health widgets. */
export const HEALTH_POLL_INTERVAL_MS = 15000;

export * from './enums';
export * from './assetTypes';
